import React, {ComponentType, ReactNode, useEffect, useMemo, useRef, useState} from 'react';
import {MessageBox} from 'src/components/messageBox/MessageBox';
import {MsgStatus} from "../common/enum";
import {zIndex} from "../Global.style";

export const MessageContext = React.createContext({
    showMessage(msg: string, type?: MsgStatus, content?: string): symbol | undefined {
       return Symbol("modal");
    },
    showError(error: any, title?: string): void{

    },
    destoryMessageBox(modalId: symbol) {

    }
});

type IProps = {
    children: ReactNode
}
export interface IMessage {
    destoryComponent(): void
}
export default function MessageProvider(props: IProps) {
    const [ messageData, setMessageData ] = useState<{[propName: symbol]: {component: ComponentType<any>, props: any}}>({});
    const messageDataRef = useRef<{[propName: symbol]: {component: ComponentType<any>, props: any}}>({});

    useEffect(() => {
        messageDataRef.current = messageData;
    }, [messageData]);

    function showMessage(msg: string, type?: MsgStatus, content?: string): symbol | undefined {
        if (!msg) {
          return ;
        }
        let modalId = Symbol("modal");
        let data = Object.assign({}, messageDataRef.current);
        data[modalId] = {
            component: MessageBox,
            props: {
                title: msg,
                content: content,
                type: type ?? MsgStatus.warn
            }
        };
        setMessageData(data);
        return modalId;
    }



    return (
        <MessageContext.Provider value={{
            showMessage,
            showError(error: any, title?: string) {
                let isZh = localStorage.getItem("lang") !== 'en_US';
                let msg = typeof error === "string" ? error : "failed";
                if (error.code) {
                    switch (error.code) {
                        case 4001:
                            msg = "Trade reject";
                            break;
                        default:
                            let resMsg = (error && error.data && error.data.message) || JSON.stringify(error);
                            msg = `Trade failed：${resMsg}`;
                    }
                }

                showMessage(title || msg || "ERROR", MsgStatus.warn, title ? msg : "")
            },
            destoryMessageBox(modalId: symbol) {
                setTimeout(() => {
                  let data = Object.assign({}, messageDataRef.current);
                  delete data[modalId];
                  setMessageData(data);
                }, 50);
            }
        }}>
            <>
                { props.children }
                <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 4001}}>
                    {
                        Object.getOwnPropertySymbols(messageData).map((item, index) => {
                            let Component = messageData[item].component;
                            let props = messageData[item].props || {};
                            return <Component key={index} {...props} destoryComponent={() => {
                                setTimeout(() => {
                                    let data = Object.assign({}, messageDataRef.current);
                                    delete data[item];
                                    setMessageData(data);
                                }, 70);
                            }} />
                        })
                    }
                </div>
            </>
        </MessageContext.Provider>
    )
}
